import { Id, OrganizationInvite, OrganizationJoinRequest, OrganizationUser, SuccessResponse, User } from '../types';
import { abibApi, tags, methods } from './';

// '/orgs/{org}/users': {
//     '/': 'get', // done
//     '/setOwner': 'put',
//     '/invites': 'get',
//     '/invites': 'post',
//     '/invites': 'delete',
//     '/acceptInvite': 'get',
//     '/joinRequests': 'get',
//     '/joinRequests': 'post',
//     '/joinRequests': 'delete',
//     '/joinRequests/accept/{user}': 'post',
//     '/joinRequests/reject/{user}': 'delete',
//     '/joinRequests/block/{user}': 'post',
//     '/joinRequests/blocked': 'get',
//     '/joinRequests/unblock/{user}': 'post',
//     '/assignRole/{user}/{roleName}': 'put', // done
//     '/remove/{user}': 'delete', // done
//   };
const apiOrganizationUsers = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationUsers: builder.query<{ items: OrganizationUser[] }, { org_id: Id }>({
      query: ({ org_id }) => {
        return {
          method: methods.GET,
          url: `/orgs/${org_id}/users`,
        };
      },
      providesTags: (result, error, { org_id }) => [{ type: tags.organizationUsers, org_id }],
      transformResponse: ({ data }, meta, arg) => ({
        items: data
      }),
    }),
    //     '/setOwner': 'put',
    setOrganizationOwner: builder.mutation<any, { org_id: Id, user_id: Id }>({
      query: ({ org_id, user_id }) => {
        return {
          method: methods.PUT,
          url: `/orgs/${org_id}/users/setOwner`,
          body: {
            user_id
          },
        };
      },
      invalidatesTags: (result, error, { org_id, user_id }) => [
        tags.currentUser,
        { type: tags.organization, org_id },
        { type: tags.organizationInvites, org_id },
        { type: tags.organizationJoinRequests, org_id },
      ]
    }),
    //     '/invites': 'get',
    getOrganizationInvites: builder.query<{ items: OrganizationInvite[] }, { org_id: Id }>({
      query: ({ org_id }) => {
        return {
          method: methods.GET,
          url: `/orgs/${org_id}/users/invites`,
        };
      },
      providesTags: (result, error, { org_id }) => [{ type: tags.organizationInvites, org_id }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    //     '/invites': 'post',
    sendOrganizationInvite: builder.mutation<unknown, { org_id: Id, email: string }>({
      query: ({ org_id, email }) => {
        return {
          method: methods.POST,
          url: `/orgs/${org_id}/users/invites`,
          body: {
            email
          },
        };
      },
      invalidatesTags: (result, error, { org_id, email }) => [
        { type: tags.organizationInvites, org_id },
      ],
    }),
    //     '/invites': 'delete',
    withdrawOrganizationInvite: builder.mutation<unknown, { org_id: Id, email: string }>({
      query: ({ org_id, email }) => {
        return {
          method: methods.DELETE,
          url: `/orgs/${org_id}/users/invites`,
          body: {
            email
          },
        };
      },
      invalidatesTags: (result, error, { org_id, email }) => [
        { type: tags.organizationInvites, org_id },
      ],
    }),
    //     '/acceptInvite': 'get',
    acceptOrganizationInvite: builder.mutation<unknown, { org_id: Id, token: string }>({
      query: ({ org_id, token }) => {
        return {
          method: methods.GET,
          url: `/orgs/${org_id}/users/acceptInvite?token=${token}`,
        };
      },
      invalidatesTags: (result, error, { org_id, token }) => [
        tags.currentUser,
        { type: tags.organizationInvites, org_id },
        { type: tags.organizationUsers, org_id },
      ],
    }),

    //     '/joinRequests': 'get',
    getOrganizationJoinRequests: builder.query<{ items: OrganizationJoinRequest[] }, { org_id: Id }>({
      query: ({ org_id }) => {
        return {
          method: methods.GET,
          url: `/orgs/${org_id}/users/joinRequests`,
        };
      },
      providesTags: (result, error, { org_id }) => [{ type: tags.organizationJoinRequests, org_id }],
      transformResponse: ({ data }, meta, arg) => ({ items: data }),
    }),
    //     '/joinRequests/blocked': 'get',
    getorganizationBlockedJoinRequests: builder.query<{ items: OrganizationJoinRequest[] }, { org_id: Id }>({
      query: ({ org_id }) => {
        return {
          method: methods.GET,
          url: `/orgs/${org_id}/users/joinRequests/blocked`,
        };
      },
      providesTags: (result, error, { org_id }) => [{ type: tags.organizationBlockedJoinRequests, org_id }],
      transformResponse: ({ data }, meta, arg) => ({ items: data }),
    }),
    //     '/joinRequests': 'post',
    sendOrganizationJoinRequest: builder.mutation<SuccessResponse, { org_id: Id }>({
      query: ({ org_id }) => {
        return {
          method: methods.POST,
          url: `/orgs/${org_id}/users/joinRequests`,
        };
      },
      invalidatesTags: (result, error, { org_id }) => [
        tags.currentUser,
        { type: tags.organizationJoinRequests, org_id },
      ],
      transformResponse: (response, meta, arg) => response as SuccessResponse,
    }),
    //     '/joinRequests': 'delete',
    withdrawOrganizationJoinRequest: builder.mutation<SuccessResponse, { org_id: Id }>({
      query: ({ org_id }) => {
        return {
          method: methods.DELETE,
          url: `/orgs/${org_id}/users/joinRequests`,
        };
      },
      invalidatesTags: (result, error, { org_id }) => [
        tags.currentUser,
        { type: tags.organizationJoinRequests, org_id },
        { type: tags.organizationBlockedJoinRequests, org_id },
      ],
    }),
    //     '/joinRequests/accept/{user}': 'post',
    acceptOrganizationJoinRequest: builder.mutation<unknown, { org_id: Id, user_id: number }>({
      query: ({ org_id, user_id }) => {
        return {
          method: methods.POST,
          url: `/orgs/${org_id}/users/joinRequests/accept/${user_id}`,
        };
      },
      invalidatesTags: (result, error, { org_id }) => [
        { type: tags.organizationUsers, org_id },
        { type: tags.organizationJoinRequests, org_id },
      ],
    }),
    //     '/joinRequests/reject/{user}': 'delete',
    rejectOrganizationJoinRequest: builder.mutation<unknown, { org_id: Id, user_id: number }>({
      query: ({ org_id, user_id }) => {
        return {
          method: methods.DELETE,
          url: `/orgs/${org_id}/users/joinRequests/reject/${user_id}`,
        };
      },
      invalidatesTags: (result, error, { org_id }) => [
        { type: tags.organizationJoinRequests, org_id },
        { type: tags.organizationBlockedJoinRequests, org_id },
      ],
    }),
    //     '/joinRequests/block/{user}': 'post',
    blockOrganizationJoinRequest: builder.mutation<unknown, { org_id: Id, user_id: number }>({
      query: ({ org_id, user_id }) => {
        return {
          method: methods.POST,
          url: `/orgs/${org_id}/users/joinRequests/block/${user_id}`,
        };
      },
      invalidatesTags: (result, error, { org_id }) => [
        { type: tags.organizationJoinRequests, org_id },
        { type: tags.organizationBlockedJoinRequests, org_id },
      ],
    }),
    //     '/joinRequests/unblock/{user}': 'post',
    unblockOrganizationJoinRequest: builder.mutation<unknown, { org_id: Id, user_id: number }>({
      query: ({ org_id, user_id }) => {
        return {
          method: methods.POST,
          url: `/orgs/${org_id}/users/joinRequests/unblock/${user_id}`,
        };
      },
      invalidatesTags: (result, error, { org_id }) => [
        { type: tags.organizationBlockedJoinRequests, org_id },
      ],
    }),

    removeOrganizationUser: builder.mutation<SuccessResponse<unknown>, { org_id: Id, user_id: number }>({
      query: ({ org_id, user_id }) => {
        return {
          method: methods.DELETE,
          url: `/orgs/${org_id}/users/remove/${user_id}`
        };
      },
      invalidatesTags: (result, error, { org_id, user_id }) => [
        { type: tags.organizationUsers, org_id },
      ],
    }),

    assignOrganizationRole: builder.mutation<SuccessResponse<unknown>, { org_id: Id, user_id: number, roleName: string }>({
      query: ({ org_id, user_id, roleName }) => {
        return {
          method: methods.PUT,
          url: `/orgs/${org_id}/users/assignRole/${user_id}/${roleName}`
        };
      },
      invalidatesTags: (result, error, { org_id, user_id, roleName }) => [
        // tags.currentUser,
        { type: tags.organization, org_id },
        { type: tags.organizationUsers, org_id },
      ],
    }),
  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetOrganizationInvitesQuery,
  useLazyGetOrganizationInvitesQuery,

  useSendOrganizationInviteMutation,
  useAcceptOrganizationInviteMutation,
  useWithdrawOrganizationInviteMutation,

  useGetOrganizationJoinRequestsQuery,
  useLazyGetOrganizationJoinRequestsQuery,
  useGetorganizationBlockedJoinRequestsQuery,

  useSendOrganizationJoinRequestMutation,
  useWithdrawOrganizationJoinRequestMutation,
  useAcceptOrganizationJoinRequestMutation,
  useRejectOrganizationJoinRequestMutation,
  useBlockOrganizationJoinRequestMutation,
  useUnblockOrganizationJoinRequestMutation,

  useGetOrganizationUsersQuery,
  useLazyGetOrganizationUsersQuery,

  useRemoveOrganizationUserMutation,
  useAssignOrganizationRoleMutation,
} = apiOrganizationUsers;
